import React from "react";
import Cloud from "../../assets/Cloud-ffvii-battle.png";

export default function FooterCard() {
  return (
    <div className="font-light text-sm text-gray-300 flex items-center gap-4 w-full py-1">
      <img src={Cloud} alt="Cloud Strife" className="w-16 h-auto shrink-0" />
      <p className="leading-relaxed">
        Built with{" "}
        <a className="font-medium text-white" href="https://create-react-app.dev/">Create React App</a>{" "}
        and{" "}
        <a className="font-medium text-white" href="https://tailwindcss.com/">Tailwind CSS.</a>{" "}
        Deployed with{" "}
        <a className="font-medium text-white" href="https://www.netlify.com/">Netlify</a>{" "}
        and animated using{" "}
        <a className="font-medium text-white" href="https://www.framer.com/motion/">Framer Motion</a>.
      </p>
    </div>
  );
}
